var WORD_WRAP_DELIMITER = ',';
var WORD_WRAP_MAX_CHARS = 150;
function wordWrap(items) {
  var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : WORD_WRAP_DELIMITER;
  var maxLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : WORD_WRAP_MAX_CHARS;
  if (items && items.length) {
    var result = [];
    var currentLine = '';
    items.forEach(item => {
      var nextItemString = currentLine.length ? delimiter.concat(item) : String(item);
      if (currentLine.length + nextItemString.length > maxLength) {
        result.push(currentLine);
        currentLine = String(item);
      } else {
        currentLine = currentLine.concat(nextItemString);
      }
    });
    result.push(currentLine);
    return result;
  }
  return [];
}
export default wordWrap;